import React, { useContext } from 'react';
import { func, object } from 'prop-types';
import { translate } from 'react-i18next';

import { CheckIcon } from '@snapask/common-components';
import LiveCarousel from './components/LiveCarousel';

import ContextStore from '@dragonfruit/services/createContext.js';
import Link from '@dragonfruit/components/Link';

import styles from './LiveSection.scss';

import {
  getSubscriptionPriceInfo,
  getPriceUnitString,
} from '@dragonfruit/utils/priceUnit';

function LiveSection({ t, liveGroups }) {
  const { urlLocale } = useContext(ContextStore);

  const liveFeatures = t('premium.live_groups.features', {
    returnObjects: true,
    defaultValue: [],
  }).filter(feature => feature !== '-');

  const { pictureGroups, planGroups } = liveGroups;

  const renderFeatures = (feature, index) => (
    <li key={index} className={styles.listItem}>
      <span className={styles.check}>
        <CheckIcon width={24} height={24} className={styles.checkIcon} />
      </span>
      <span className={styles.text}> {feature}</span>
    </li>
  );
  const getPriceString = ({
    billingCyclePerMonths,
    contractPeriod,
    price,
    currency,
    displayCurrency,
    planType,
    isContract,
  }) => {
    const { priceDescription } = getSubscriptionPriceInfo({
      billingCyclePerMonths,
      contractPeriod,
      isContract,
      price,
      planType,
      currency,
      displayCurrency,
    });

    const { displayPriceWithCurrency, displayPriceUnit } = getPriceUnitString({
      billingCyclePerMonths,
      contractPeriod,
      isContract,
      price,
      currency,
      displayCurrency,
    });
    const normalPriceString = `${displayPriceWithCurrency} ${displayPriceUnit} `;

    return isContract
      ? `${normalPriceString} (${priceDescription})`
      : normalPriceString;
  };

  const renderPlans = (plan, index) => {
    const priceString = getPriceString(plan);

    return (
      <Link
        key={index}
        className={styles.plan}
        to={`/${urlLocale}/purchase/${plan.paymentMethodId}`}
      >
        {plan.highlight && (
          <div className={styles.highlight}>{plan.highlight}</div>
        )}
        <h5 className={styles.name}>{plan.name}</h5>
        <div className={styles.price}>{priceString}</div>
      </Link>
    );
  };
  return (
    <div className={styles.root}>
      <div className={styles.plans}>
        <ul className={styles.featureList}>
          {liveFeatures.map(renderFeatures)}
        </ul>
        <div className={styles.planGroups}>{planGroups.map(renderPlans)}</div>
      </div>
      <div className={styles.carousel}>
        <LiveCarousel pictureGroups={pictureGroups} />
      </div>
    </div>
  );
}

LiveSection.propTypes = {
  liveGroups: object.isRequired,
  t: func.isRequired,
};

export default translate(['premium'])(LiveSection);



// WEBPACK FOOTER //
// ./app/containers/Premium/components/LiveSection/LiveSection.jsx